
import topMenu from './topMenu.json'
import pedidosScreen from './pedidosScreen.json'

export const ca = {
  language_name: 'Català',
  topMenu,
  pedidosScreen
}
